module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offline-mode",
    class: _vm.$style.root
  }, [(_vm.offlineSupported) ? _c('switches', {
    staticClass: "offline-switch",
    attrs: {
      "value": _vm.isOnline,
      "type-bold": true,
      "theme": "custom",
      "emit-on-mount": false
    },
    on: {
      "input": _vm.onSwitch
    }
  }) : _vm._e(), _c('b-modal', {
    ref: "offlineModeModal",
    attrs: {
      "size": "lg",
      "title": _vm.$t("pos.offline.title"),
      "ok-title": _vm.$t("terms.misc.download"),
      "close-title": _vm.$t("terms.misc.close"),
      "hide-header-close": true,
      "ok-disabled": _vm.disableDownloadBtn
    },
    on: {
      "ok": _vm.startDownload
    }
  }, [(_vm.offlineSupported) ? [(_vm.realOnline) ? [_c('b-alert', {
    attrs: {
      "variant": "info",
      "show": true
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.offline.stay-connected-to-internet')))]), _c('b-alert', {
    attrs: {
      "variant": "info",
      "show": true
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.offline.enable-persistent-storage')))])] : [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": true
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.offline.check-internet-connection')))])], _c('p', [_vm._v(_vm._s(_vm.$t('pos.offline.download-progress', {
    completed: _vm.downloads.completed,
    total: _vm.downloads.total
  })))]), (_vm.downloads.total > 0) ? _c('b-progress', {
    attrs: {
      "value": _vm.downloads.completed,
      "max": _vm.downloads.total,
      "show-progress": "",
      "animated": ""
    }
  }) : _vm._e()] : [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": true
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.offline.offline-mode-not-supported')))])]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e2bcbdc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offline-mode/OfflineMode.vue
// module id = 936
// module chunks = 1